import { Asset, InstrumentDataForPosition, InstrumentType, Position, Quote } from '@zero/shared/util-models';

export const newIsDerivativeSoldOut = (position: Position): boolean => {
  const soldOut: boolean =
    Boolean(position) &&
    position.type === InstrumentType.Derivative &&
    !position.knockedOutFlag &&
    Boolean(position.rawQuote) &&
    position.rawQuote.ask === 0 &&
    position.rawQuote.bid > 0;
  return soldOut;
};

export const isDerivativeSoldOut = (instrument: InstrumentDataForPosition, quote: Quote): boolean => {
  const soldOut: boolean =
    Boolean(instrument) &&
    instrument.type === InstrumentType.Derivative &&
    !instrument.knockedOutFlag &&
    Boolean(quote) &&
    quote.ask === 0 &&
    quote.bid > 0;
  return soldOut;
};

export const isAssetDerivativeSoldOut = (instrument: Asset, quote: Quote | undefined): boolean => {
  if (instrument && quote) {
    const soldOut: boolean =
      Boolean(instrument) &&
      instrument.instrumentType === InstrumentType.Derivative &&
      !instrument.knockedOutFlag &&
      Boolean(quote) &&
      quote.ask === 0 &&
      quote.bid > 0;
    return soldOut;
  }
  return false;
};
